export const getTime = (date: string) => new Date(date).getTime();

export const isUTC = (date: string) => date.toLowerCase().endsWith("z");
